import React, { useState } from 'react'
import $ from 'jquery'
import { Link, useNavigate } from 'react-router-dom'


export default function Forgotpassword() {
    const [emailinput, setEmailInput] = useState(true);
    const [passinput, setPassInput] = useState(false);
    const [useremail, setUserEmail] = useState('');
    const navigate = useNavigate();

    function prepareChangePass(){
        setEmailInput(false);
        setPassInput(true);
        let emailval = document.getElementById('useremail').value
        setUserEmail(emailval);
    }

    function changepass(){
        var obj={
      uemail:useremail
    }
    console.log(obj)
    $.ajax({
        type: 'POST',
        url: 'updatePassword.php',
        data: obj,
        cache: false,
        success: function (result) {
          console.log(result)
          if (result.trim() != 'fail') {
            alert('Your password saved successfully')       
             
              navigate('/');
          } else {
            alert('Cannot login. Please try once again.')
          }

        },
      });
    }

    function cancelchangepass(){
       navigate('/');
    }


  return (
    <div>
      <div className='floatcontainer'>
        {emailinput && (
        <div className='inner_form_holder' id="email_input">
            <h2>Insert your email</h2>
            <div className='case'>
                <input type="email" id="useremail"/>
                <button onClick={prepareChangePass}>Submit</button>
                <button onClick={cancelchangepass}>Cancel</button>
            </div>
        </div>
        )}
        {passinput && (
        <div className='inner_form_holder' id="pass_input">
            <h2>Insert new password</h2>
            <div className='case'>
                <input type="email" placeholder='Insert password' id="userpass"/>
                <input type="email" placeholder='Confirm password' id="confpass"/>
                <button onClick={changepass}>Submit</button>
            </div>
        </div>
        )}
      </div>
    </div>
  )
}
